document.addEventListener('DOMContentLoaded', function () {

	const playedVideos = new Set(); // To track played video IDs

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				var playButtonId = entry.target.id.split('-')[2];
				var playButton = document.getElementById("vimeo-button-" + playButtonId);

				// Check if the video has already been played
				if (playedVideos.has(entry.target.id)) {
					// Skip if already played
					return;
				}


				var player = new Vimeo.Player(entry.target);
				player.getPaused().then(function (paused) {
					var buttonStyle = window.getComputedStyle(playButton);
					if (paused && buttonStyle.display === "none") {
						player.play();
						player.on('ended', function () {
							// Mark the video as played when it ends
							playedVideos.add(entry.target.id);
						});
					}
				});
			}
		});
	},
		{
			root: null,
			rootMargin: '20px'
		});


	var allVimeo = document.querySelectorAll('[id^="vimeo-player"]');

	//HandleVimeo();
	InitObserver();


	function HandleVimeo() {
		allVimeo.forEach(function (vimeo) {
			var playButtonId = vimeo.id.split('-')[2];

			var player = new Vimeo.Player(vimeo);
			var playButton = document.getElementById("vimeo-button-" + playButtonId);

			player.on('ended', function () {
				playButton.style.display = "flex";
			});

			playButton.addEventListener("click", function () {
				this.style.display = "none";
				player.play();
			});
		});
	}


	function InitObserver() {
		allVimeo.forEach(function (vimeo) {
			observer.observe(vimeo);
		});
	}




});